import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const ListsContext = createContext(null);

const empty = { watchlist: [], favorites: [] };

export function ListsProvider({ children }) {
  const { user } = useAuth();
  const [membership, setMembership] = useState(empty);

  const refresh = useCallback(async () => {
    if (!user) { setMembership(empty); return; }
    try {
      const { data } = await api.get("/me/lists/membership");
      setMembership(data);
    } catch {
      setMembership(empty);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isIn = (listType, tmdbId, mediaType) =>
    (membership[listType] || []).some(
      (m) => m.tmdb_id === tmdbId && m.media_type === mediaType
    );

  const toggle = async (listType, item) => {
    const inList = isIn(listType, item.tmdb_id, item.media_type);
    if (inList) {
      await api.delete(`/me/${listType}/${item.media_type}/${item.tmdb_id}`);
    } else {
      await api.post(`/me/${listType}`, item);
    }
    await refresh();
    return !inList;
  };

  return (
    <ListsContext.Provider value={{ membership, refresh, isIn, toggle }}>
      {children}
    </ListsContext.Provider>
  );
}

export function useLists() {
  const ctx = useContext(ListsContext);
  if (!ctx) throw new Error("useLists must be within ListsProvider");
  return ctx;
}
